import { useDataProvider, useRecordContext } from "react-admin";
import { useNavigate } from "react-router";
import QueueIcon from "@mui/icons-material/Queue";
import { candidateRequests } from "api/candidateApi";
import { Button } from "@mui/material";

const CloneCampaignButton = ({ label = "Клонирай", campaignType }) => {
  const record = useRecordContext();
  const dataProvider = useDataProvider();
  const navigate = useNavigate();
  const handleClick = () => {
    if (!record) return;

    dataProvider.getOne(candidateRequests.campaignByType(campaignType), { id: record.id }).then(({ data }) => {
      const cleaned = {
        ...data,
        nameBg: null,
        nameEn: null,
        registrationFrom: null,
        registrationTo: null,
        ...(data?.exams
          ? {
              exams: data?.exams?.map(exam => ({
                examId: exam?.examId,
                examName: exam?.examName,
              })),
            }
          : {}),
      };
      const source = encodeURIComponent(JSON.stringify(cleaned));
      navigate(`/${candidateRequests.campaignByType(campaignType)}/create?source=${source}`, {
        state: { isClone: true },
      });
    });
  };

  return (
    <Button
      onClick={handleClick}
      startIcon={<QueueIcon />}
    >
      {label}
    </Button>
  );
};

export default CloneCampaignButton;
